import api from "../../../utils/api"; // ✅ Only import your custom API

export const fetchArchitecturalRequests = () =>
  api.get(`/architectural-requests`);

export const fetchStatuses = () =>
  api.get(`/statuses/architectural`);

export const fetchRequestTypes = async () => {
  const response = await api.get(`/architectural-request-types`);
  return response.data;
};
